/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { setCenterGraphCompare } from "../store/slice/roomSlices/exploreRoomSlice"
import exploreFields from "../store/constants/exploreFields"
import store from "../store/store";

export const updateExploreRoom = (path, data) => {
    const dispatch = store.dispatch;
    const keys = path.split("/:");
    const root = keys[0];

    switch (root) {
        case exploreFields.CENTER_GRAPH_COMPARE:
            dispatch(setCenterGraphCompare(data))
            break;

        default:
            console.log("case: ", root, "not yet implemented");
            break;
    }
};